<template>
    <div>

    </div>
</template>

<script>
  export default {
    name: 'room',
  };
</script>

<style scoped>

</style>